import type {
  BetslipActions,
  BetslipStore,
  SliceCreator,
} from "@/features/betslip/stores/types";

export const betslipTabs = ["active", "pending", "settled"] as const;
export type BetslipTab = (typeof betslipTabs)[number];

export const isBetslipTab = (value: string): value is BetslipTab =>
  betslipTabs.some((tab) => tab === value);

export const initialTabState: Pick<BetslipStore, "tab"> = { tab: "active" };

type TabActions = Pick<BetslipActions, "setTab">;

export const tabSlice: SliceCreator<typeof initialTabState & TabActions> = (
  set,
) => ({
  ...initialTabState,

  // Tabs emits a raw string; commit it only when it names a real tab so
  // callers stay cast-free.
  setTab: (value) => {
    if (isBetslipTab(value)) set({ tab: value });
  },
});
